<template>
  <div class="slector">
    <div class="slectBox" :class="{'on':show}" @click="show=true">{{showText===''?'请选择':showText}}</div>
    <!-- 时间弹框 -->
    <van-popup v-model="show" round position="bottom">
      <van-picker :title="title" show-toolbar :columns="columns" cancel-button-text="清空" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    columns: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
      // showText: '请选择'
    };
  },
  computed: {
    showText: function() {
      if (this.value === '') {
        return '请选择';
      } else {
        let val = this.columns.filter((item) => {
          return item.value === this.value;
        });
        if (JSON.stringify(val) === '[]') {
          return '请选择';
        } else {
          return val[0].text;
        }
      }
    }
  },
  methods: {
    onConfirm(val) {
      if (val !== undefined) {
        this.$emit('update:value', val.value);
      }
      this.show = false;
    },
    onCancel(val) {
      this.$emit('update:value', '');
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.slector {
  .slectBox {
    height: 30px;
    background: #fff url(../assets/images/arrow.png) no-repeat 92% center;
    background-size: 12px auto;
    border-radius: 4px;
    padding-right: 30px;
    padding-left: 10px;
    line-height: 32px;
    font-size: 14px;
    color: #b1b1b1;
    text-align: left;
    border: 1px solid #dbd8d8;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &.on {
      border-color: #1abc9c;
    }
  }
}
</style>
